/** `fetch().json()` não revive `Date`: chega string ISO em runtime. Aceita os dois e devolve "AAAA-MM-DD" (o que `<input type="date">` espera). */
export function paraInputDate(valor: Date | string | null | undefined): string {
  if (!valor) {
    return '';
  }
  const data = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(data.getTime())) {
    return '';
  }
  return data.toISOString().slice(0, 10);
}

export function paraExibicao(valor: Date | string | null | undefined): string {
  const iso = paraInputDate(valor);
  if (!iso) {
    return '—';
  }
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano}`;
}
